import { connect } from 'react-redux'
import mapComponent from './component'
import { mapActiveMunicipality } from 'components/map/actions'
import { Dispatch } from 'redux'

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    mouseOverHandler: (id: string) => {
      dispatch(mapActiveMunicipality(id))
    }
  }
}

export const Map = connect(
  null,
  mapDispatchToProps
)(mapComponent)

export default Map
